<template>
  <div>
    <ConfigListItem
      :label="anLabel"
      :value="strValue"
      :date="maxUpdatedAt"
      :login="maxUpdatedBy"
      @click="openEditDialog"
    />

    <ODialog ref="dialog" :max-width="800">
      <v-card>
        <ODialogBar :title="`Origem do ${anLabel}`" @close="dismiss" />
        <v-card-text class="pa-6">
          <div class="d-flex">
            <OVerticalTabs
              class="mr-6"
              v-model="clonedValues.source"
              :tabs="[
                { value: 'sensor', text: 'Valor simples' },
                { value: 'can', text: 'CAN' }
              ]"
            />
            <v-tabs-items class="flex-grow-1" v-model="clonedValues.source">
              <div class="px-4" v-if="clonedValues.source == null">
                Escolha um valor da lista ao lado.
              </div>

              <v-tab-item value="sensor" class="px-4">
                <v-select
                  label="Valor"
                  placeholder="Selecione..."
                  v-model="clonedValues.value"
                  :items="opts"
                  item-text="label"
                />
              </v-tab-item>

              <v-tab-item value="can" class="px-4">
                <SelectCANVariable
                  :canDictId="canDictId"
                  v-model="clonedValues.canVariable"
                />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-card-text>
        <v-card-text
          class="pa-6 d-flex gap-6"
          style="border-top: 1px solid #ccc"
        >
          <OSelect
            class="w-1/2"
            label="Label no gráfico"
            placeholder="Selecione..."
            v-model="clonedValues.label"
            :items="labelOpts"
            item-text="label"
            clearable
          />

          <OTextField
            class="w-1/2"
            label="Escala (max ou min:max)"
            v-model="clonedValues.scale"
          />
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          txtApply="Salvar"
          @cancel="dismiss"
          @apply="save"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import ConfigListItem from './ConfigListItem.vue'
import { mostRecentlyUpdated, getCfg } from './config-utils.js'
import VehicleCfgs from 'vehicle-cfgs'
import OVerticalTabs from './OVerticalTabs.vue'
import SelectCANVariable from './SelectCANVariable.vue'

// usado aqui e na tela de cópia de configs
export function displayValue(allConfigs, anNumber) {
  let X = anNumber
  let cfgs = {
    source: getCfg(allConfigs, `an${X}source`),
    value: getCfg(allConfigs, `valor-an-${X}`),
    canDict: getCfg(allConfigs, `canDict`),
    canVariable: getCfg(allConfigs, `an${X}CanVariable`)
  }

  let suffix = getCfg(allConfigs, `an${X}label`)
  suffix = suffix == null ? '' : ` (${suffix})`

  switch (cfgs.source) {
    case 'sensor': {
      let optValue = cfgs.value
      let opts = VehicleCfgs.get(`valor-an-${X}`, 'opts')
      let opt = opts.find((x) => x.value == optValue)
      if (opt == null) return '??'
      else return opt.label + suffix
    }
    case 'can': {
      let y = cfgs.canVariable
      return `CAN variable=${y && y.code}` + suffix
    }
    default:
      return '??'
  }
}

export function copyValue(allConfigs, anNumber) {
  let X = anNumber
  let props = [
    `an${X}source`,
    `valor-an-${X}`,
    `an${X}label`,
    `an${X}scale`,
    `an${X}CanVariable`
  ]

  let result = {}
  for (let p of props) result[p] = getCfg(allConfigs, p)
  return result
}

export default {
  components: { ConfigListItem, OVerticalTabs, SelectCANVariable },
  props: {
    allConfigs: { required: true },
    configDef: { required: true }
  },
  data() {
    let X = this.configDef.anNumber
    return {
      clonedValues: { source: 'sensor' },
      opts: VehicleCfgs.get(`valor-an-${X}`, 'opts'),
      labelOpts: VehicleCfgs.get(`an${X}label`, 'opts')
    }
  },
  computed: {
    canDictId() {
      return getCfg(this.allConfigs, 'canDictId')
    },
    anLabel() {
      return `AN` + this.anNumber
    },
    anNumber() {
      return this.configDef.anNumber
    },
    strValue() {
      return displayValue(this.allConfigs, this.anNumber)
    },
    mostRecent() {
      let X = this.anNumber
      return mostRecentlyUpdated(
        this.allConfigs,
        `an${X}source`,
        `valor-an-${X}`,
        `an${X}CanVariable`,
        `an${X}label`,
        `an${X}scale`
      )
    },
    maxUpdatedAt() {
      return this.mostRecent && this.mostRecent.updatedAt
    },
    maxUpdatedBy() {
      return this.mostRecent && this.mostRecent.updatedBy
    }
  },
  methods: {
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    openEditDialog() {
      let X = this.anNumber
      this.clonedValues = {
        source: getCfg(this.allConfigs, `an${X}source`),
        value: getCfg(this.allConfigs, `valor-an-${X}`),
        label: getCfg(this.allConfigs, `an${X}label`),
        scale: getCfg(this.allConfigs, `an${X}scale`),
        canDict: getCfg(this.allConfigs, `canDict`),
        canVariable: getCfg(this.allConfigs, `an${X}CanVariable`)
      }

      return this.$refs.dialog.$open()
    },
    async save() {
      let payload = {}
      let X = this.anNumber
      payload[`an${X}source`] = this.clonedValues.source
      payload[`valor-an-${X}`] = this.clonedValues.value
      payload[`an${X}label`] = this.clonedValues.label
      payload[`an${X}scale`] = this.clonedValues.scale
      payload[`an${X}CanVariable`] = this.clonedValues.canVariable
      this.$emit('save', payload)
      this.dismiss()
    }
  }
}
</script>

<style></style>
